/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class DailyAbsencesRoute extends Route {
  queryParams = {
    reportDate: {
      refreshModel: true,
      as: 'date',
    },
    groupId: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let year = moment().year();
    let date = isEmpty(params.reportDate)
      ? moment().format('YYYY-MM-DD')
      : params.reportDate;
    let groupId = params.groupId;

    return hash({
      records: this.store.query('attendance/record', {
        dateFrom: date,
        dateTo: date,
        groupId,
      }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
      groups: this.store.query('group', { year }),
    });
  }
}
